// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SlackNotificationLinker piggy-backs on .notification-emails-section for
   the outer card (background, border, brand left bar, sibling spacing),
   so this file only carries the Slack-specific interior styling. */

.slack-notify-linker .slack-notify-linker-heading-label {
  flex: 1 1;
}

.slack-notify-linker .slack-notify-refresh-btn {
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.slack-notify-linker .slack-notify-refresh-btn:hover {
  background-color: #ececec;
  color: #353b43;
}

.slack-notify-linker .slack-notify-refresh-btn:disabled {
  cursor: default;
  opacity: 0.6;
}

.slack-notify-linker .slack-notify-loading {
  display: flex;
  justify-content: center;
  padding: 24px;
  color: #5616ea;
}

.slack-notify-linker .slack-notify-empty {
  text-align: center;
  padding: 8px;
}

.slack-notify-linker .slack-notify-empty p {
  margin: 0 0 14px 0;
  color: #555;
  font-size: 0.9rem;
  line-height: 1.45;
}

.slack-notify-linker .slack-notify-connect-btn,
.slack-notify-linker .slack-notify-add-workspace-btn {
  display: inline-flex;
  align-items: center;
  border: 1px solid #5616ea;
  background-color: #ffffff;
  color: #5616ea;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.slack-notify-linker .slack-notify-connect-btn:hover,
.slack-notify-linker .slack-notify-add-workspace-btn:hover {
  background-color: #f3eaff;
}

.slack-notify-linker .slack-notify-add-workspace-btn {
  margin-top: 10px;
}

.slack-notify-linker .slack-notify-workspace {
  margin-bottom: 14px;
  background-color: #ffffff;
  border: 1px solid #ececec;
  border-radius: 8px;
}

.slack-notify-linker .slack-notify-workspace-header {
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 0.85rem;
  font-weight: 600;
  color: #353b43;
}

.slack-notify-linker .slack-notify-no-channels {
  padding: 12px;
  font-size: 0.85rem;
  color: #777;
  font-style: italic;
}

.slack-notify-linker .slack-notify-channels {
  display: flex;
  flex-direction: column;
  padding: 4px 8px 8px;
  max-height: 220px;
  overflow-y: auto;
}

.slack-notify-linker .slack-notify-channel-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 6px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.88rem;
  color: #333;
  transition: background-color 0.12s ease;
}

.slack-notify-linker .slack-notify-channel-row:hover {
  background-color: #f6f1ff;
}

.slack-notify-linker .slack-notify-channel-icon {
  color: #6b7280;
  font-size: 0.85rem;
}

.slack-notify-linker .slack-notify-channel-name {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.slack-notify-linker .slack-notify-channel-badge {
  background-color: #ececec;
  color: #555;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 999px;
  margin-left: 6px;
  flex-shrink: 0;
}

.slack-notify-linker .slack-notify-error {
  margin-top: 10px;
  padding: 8px 10px;
  background-color: #fdecea;
  border-radius: 6px;
  border-left: 3px solid #e53935;
  color: #611a15;
  font-size: 0.85rem;
}

.slack-notify-linker .slack-notify-hint {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 12px;
  padding: 8px 10px;
  background-color: #ffffff;
  border: 1px solid #ececf2;
  border-radius: 6px;
  font-size: 0.78rem;
  color: #666;
  line-height: 1.4;
}

.slack-notify-linker .slack-notify-hint-icon {
  color: #5616ea;
  margin-top: 2px;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/SlackNotificationLinker.css"],"names":[],"mappings":"AAAA;;mEAEmE;;AAEnE;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* SlackNotificationLinker piggy-backs on .notification-emails-section for\r\n   the outer card (background, border, brand left bar, sibling spacing),\r\n   so this file only carries the Slack-specific interior styling. */\r\n\r\n.slack-notify-linker .slack-notify-linker-heading-label {\r\n  flex: 1;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-refresh-btn {\r\n  background: none;\r\n  border: none;\r\n  color: #6b7280;\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  border-radius: 6px;\r\n  transition: background-color 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-refresh-btn:hover {\r\n  background-color: #ececec;\r\n  color: #353b43;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-refresh-btn:disabled {\r\n  cursor: default;\r\n  opacity: 0.6;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-loading {\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 24px;\r\n  color: #5616ea;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-empty {\r\n  text-align: center;\r\n  padding: 8px;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-empty p {\r\n  margin: 0 0 14px 0;\r\n  color: #555;\r\n  font-size: 0.9rem;\r\n  line-height: 1.45;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-connect-btn,\r\n.slack-notify-linker .slack-notify-add-workspace-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  border: 1px solid #5616ea;\r\n  background-color: #ffffff;\r\n  color: #5616ea;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  padding: 8px 14px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-connect-btn:hover,\r\n.slack-notify-linker .slack-notify-add-workspace-btn:hover {\r\n  background-color: #f3eaff;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-add-workspace-btn {\r\n  margin-top: 10px;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-workspace {\r\n  margin-bottom: 14px;\r\n  background-color: #ffffff;\r\n  border: 1px solid #ececec;\r\n  border-radius: 8px;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-workspace-header {\r\n  padding: 10px 12px;\r\n  border-bottom: 1px solid #f0f0f0;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  color: #353b43;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-no-channels {\r\n  padding: 12px;\r\n  font-size: 0.85rem;\r\n  color: #777;\r\n  font-style: italic;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-channels {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 4px 8px 8px;\r\n  max-height: 220px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-channel-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 4px 6px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 0.88rem;\r\n  color: #333;\r\n  transition: background-color 0.12s ease;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-channel-row:hover {\r\n  background-color: #f6f1ff;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-channel-icon {\r\n  color: #6b7280;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-channel-name {\r\n  flex: 1;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  min-width: 0;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-channel-badge {\r\n  background-color: #ececec;\r\n  color: #555;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  padding: 1px 6px;\r\n  border-radius: 999px;\r\n  margin-left: 6px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-error {\r\n  margin-top: 10px;\r\n  padding: 8px 10px;\r\n  background-color: #fdecea;\r\n  border-radius: 6px;\r\n  border-left: 3px solid #e53935;\r\n  color: #611a15;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-hint {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 6px;\r\n  margin-top: 12px;\r\n  padding: 8px 10px;\r\n  background-color: #ffffff;\r\n  border: 1px solid #ececf2;\r\n  border-radius: 6px;\r\n  font-size: 0.78rem;\r\n  color: #666;\r\n  line-height: 1.4;\r\n}\r\n\r\n.slack-notify-linker .slack-notify-hint-icon {\r\n  color: #5616ea;\r\n  margin-top: 2px;\r\n  flex-shrink: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
